import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { CrudStore } from 'core/types/crudStore'

export const deletePartnerFlagRequest = async (entryId: string) => {
  const crud = CrudStore.get(CrudStoreItem.PartnerFlagsRequests)

  return crud.delete('519', { EntryId: entryId })
}
